import React from "react";
import { Autocomplete, Chip, TextField, Typography, Box } from "@mui/material";

export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

// Splits pasted "a@x.com, b@y.com; c@z.com" and dedupes (case-insensitive).
const normalize = (items) => {
  const seen = new Set();
  const out = [];
  items.forEach((item) => {
    const raw = typeof item === "string" ? item : item?.email || "";
    raw
      .split(/[,;\s]+/)
      .map((e) => e.trim())
      .filter(Boolean)
      .forEach((e) => {
        const key = e.toLowerCase();
        if (!seen.has(key)) {
          seen.add(key);
          out.push(e);
        }
      });
  });
  return out;
};

const filterOptions = (options, { inputValue }) => {
  const q = inputValue.trim().toLowerCase();
  const matches = q
    ? options.filter(
        (o) =>
          o.email.toLowerCase().includes(q) ||
          (o.name || "").toLowerCase().includes(q),
      )
    : options;
  return matches.slice(0, 50);
};

const RecipientsField = ({
  label,
  value,
  onChange,
  options = [],
  loading = false,
  required = false,
  error = false,
  helperText,
}) => {
  const hasInvalid = value.some((e) => !EMAIL_REGEX.test(e));

  return (
    <Autocomplete
      multiple
      freeSolo
      autoSelect
      filterSelectedOptions
      loading={loading}
      options={options}
      filterOptions={filterOptions}
      value={value}
      onChange={(_, newValue) => onChange(normalize(newValue))}
      getOptionLabel={(o) => (typeof o === "string" ? o : o.email)}
      isOptionEqualToValue={(o, v) =>
        (typeof o === "string" ? o : o.email).toLowerCase() ===
        (typeof v === "string" ? v : v.email).toLowerCase()
      }
      renderOption={(props, option) => {
        const { key, ...rest } = props;
        return (
          <Box component="li" key={key} {...rest}>
            <Box>
              <Typography variant="body2">{option.email}</Typography>
              {option.name && (
                <Typography variant="caption" color="text.secondary">
                  {option.name}
                </Typography>
              )}
            </Box>
          </Box>
        );
      }}
      renderTags={(tags, getTagProps) =>
        tags.map((email, index) => {
          const { key, ...tagProps } = getTagProps({ index });
          return (
            <Chip
              key={key}
              size="small"
              label={email}
              color={EMAIL_REGEX.test(email) ? "default" : "error"}
              {...tagProps}
            />
          );
        })
      }
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          required={required}
          error={error || hasInvalid}
          helperText={
            hasInvalid ? "Some addresses are not valid emails" : helperText
          }
        />
      )}
    />
  );
};

export default RecipientsField;
